module.exports = __webpack_public_path__ + "img/non cov fixed activities.53d9b879.png";